import { Row, Col, Upload, Checkbox, Spin } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useState } from "react";
import { DeleteFileFinep, PostFileFinep } from "../../../API/FileFinepAPI";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../Hooks/useAuth";
import { FileFinepModel } from "../../../Models/FileFinepModel";
import ExistedInputForm from "../ExistedInputForm";
import type { UploadProps } from "antd/es/upload";
import "./styles.css";


const { Dragger } = Upload;
interface UploadInputsProps {
    docType: 0 | 1 | 2 | 3 | 4 | 5;
    fileId?: string;
    HandleCheckChange?: (id: string, value: boolean) => void;
    identification?: string;
}
const UploadInputForm = ({ docType, fileId, HandleCheckChange, identification }: UploadInputsProps) => {
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState<boolean>(false);
    const { registerId } = useParams();
    const { userEmail } = useAuth();
    const [fileFinep, setFileFinep] = useState<FileFinepModel>({} as FileFinepModel);
    const handleUpload: UploadProps["customRequest"] = async ({ file }) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("files", file as File);
        try {
            if (fileId) await DeleteFileFinep(fileId);
            const response = await PostFileFinep(formData, {
                docType: docType,
                pathName: (file as File).name,
                registerId: registerId ?? "",
                userEmail: userEmail,
            });
            setFileFinep(response.data[0]);
        } catch (error) {
            console.error("Erro no upload:", error);
        } finally {
            setLoading(false);
        }
    };
    function onClick(val: boolean) {
        setValue(val);
        HandleCheckChange?.(identification ?? "", val);
    }
    return (
        <>
            {loading && <Spin />}
            {fileFinep.id ? (
                <ExistedInputForm fileFinep={fileFinep} />
            ) : (
                <Row gutter={[16, 16]} style={{ marginTop: 0, width: "100%" }}>
                    <Col flex="60%">
                        <Dragger
                            customRequest={handleUpload}
                            showUploadList={false}
                            style={{ width: "100%" }}
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Arraste e solte um arquivo aqui ou clique para selecionar</p>
                        </Dragger>
                    </Col>

                    <Col flex="40%" style={{ display: "flex", justifyContent: "center", gap: "120px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <Checkbox /> Sim
                        </label>
                        <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <Checkbox id={identification} value={value} onClick={() => onClick(!value)} /> Sim
                        </label>

                    </Col>
                </Row>
            )}
        </>
    );
};
export default UploadInputForm;